import { Box } from "@mui/material";
import { ReactNode } from "react";
import Header from "../Header";
import Footer from "../Footer";

interface PageLayoutProps {
  children: ReactNode;
  showOnlyHomeInHeader?: boolean;
}

const PageLayout = ({ children, showOnlyHomeInHeader = false }: PageLayoutProps) => {
  return (
    <Box>
      <Header showOnlyHome={showOnlyHomeInHeader} />
      {children}
      <Footer />
    </Box>
  );
};

export default PageLayout;
